// GroupCard.js
// This is the Group Card component for the Wells tab, used to hold wellcard information grouped based on the tab that users are in on the Wells tab for sampling in our sampling event form.

// Importing Well Card
import { WellCard } from "./WellCard";
// CSS Styles
import styles from "../WellsTab.module.css";

// Main GroupCard Component
export const GroupCard = ({
  group,
  isExpanded,
  onToggle,
  allWells,
  expandedCardId,
  handleCardToggle,
  allEmployees,
  qaQcEmployees,
  samplingEventMode,
  actions,
  ui,
  emitPatch,
}) => {
  // Find wells that belong to this group by matching wellId
  const groupWells = allWells.filter((well) =>
    group.wells.some((groupWell) => groupWell.wellId === well.wellId)
  );

  // Calculate stats
  const totalWellCount = groupWells.length;
  const completedWellCount = groupWells.filter(
    (well) => well.samplingCompleted
  ).length;

  return (
    <div className={styles.groupCard}>
      <div className={styles.groupCardHeader} onClick={onToggle}>
        <div className={styles.groupCardInfo}>
          <h3>{group.groupName || "Unnamed Group"}</h3>
          <div className={styles.groupCardStats}>
            <span>{`${completedWellCount}/${totalWellCount} Wells Complete`}</span>
          </div>
        </div>
        <span className={styles.expandIcon}>{isExpanded ? "▼" : "▶"}</span>
      </div>

      {isExpanded && (
        <div className={styles.groupCardContent}>
          {groupWells.length > 0 ? (
            <>
              <p>
                Click on a well card to expand and view/edit sampling details
              </p>
              {groupWells.map((well) => (
                <WellCard
                  key={well.id}
                  well={well}
                  isExpanded={expandedCardId === well.id}
                  onToggle={() => handleCardToggle(well.id)}
                  allEmployees={allEmployees}
                  qaQcEmployees={qaQcEmployees}
                  samplingEventMode={samplingEventMode}
                  actions={actions}
                  ui={ui}
                  emitPatch={emitPatch}
                />
              ))}
            </>
          ) : (
            <div className={styles.noWells}>
              <p>No wells are assigned to this group.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
